import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DropdownList from '../utils/DropdownList';
import {
    getProvinceOptions,
    getProvinceUtentiOptions
} from '../../form-helpers';

export default class SelectProvince extends Component {
    state = {
        items: [],
        isFetching: true
    };

    componentDidMount() {
        this.fetchOptions();
    }

    componentDidUpdate(prevProps) {
        if (this.props.filter !== prevProps.filter) {
            this.fetchOptions();
        }
    }

    fetchOptions() {
        const { type, filter } = this.props;

        const fn =
            type === 'all' ? getProvinceOptions : getProvinceUtentiOptions;

        fn({ q: filter }).then(options => {
            this.setState({
                items: options,
                isFetching: false
            });
        });
    }

    render() {
        const { items, isFetching } = this.state;

        return (
            <DropdownList
                items={items}
                isLoading={isFetching}
                {...this.props}
            />
        );
    }
}

SelectProvince.propTypes = {
    type: PropTypes.oneOf(['all', 'user']),
    filter: PropTypes.string
};

SelectProvince.defaultProps = {
    type: 'all'
};
